import { IconProps } from "./IconProps";

export function Bar(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path d="M21 12L3 12" />
    </svg>
  );
}
